<template>
  <LoaderIcon class="preloader-icon" aria-hidden="true" />
</template>

<script setup lang="ts">
import LoaderIcon from '@/assets/images/icons/loader.svg'

defineOptions({
  name: 'PreloaderIcon',
})
</script>

<style>
.preloader-icon {
  @apply size-4;
  @apply animate-spin;
}
</style>
